import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import Avatar from 'flarum/common/components/Avatar';
import Badge from 'flarum/common/components/Badge';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import app from 'flarum/forum/app';
export default class ModerateUserFeedbackModal extends Modal {
  activeTab = 'pending';
  loadingPending = true;
  loadingReports = true;
  actionLoading = false;
  pendingFeedbacks = [];
  pendingIncluded = [];
  reports = [];
  reportsIncluded = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    const pendingCount = this.user && this.user.attribute('pendingFeedbackCount') || 0;
    const reportCount = this.user && this.user.attribute('pendingReportCount') || 0;
    this.activeTab = pendingCount === 0 && reportCount > 0 ? 'reports' : 'pending';
    this.loadPendingFeedbacks();
    this.loadReports();
  }
  className() {
    return 'Modal Modal--large ModerateUserFeedbackModal';
  }
  title() {
    return app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.title', {
      username: this.user ? this.user.displayName() : ''
    });
  }
  loadPendingFeedbacks() {
    if (!this.user) return;
    this.loadingPending = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/trader/feedback/pending',
      params: {
        filter: {
          user: this.user.id()
        }
      }
    }).then(response => {
      this.pendingFeedbacks = response.data || [];
      this.pendingIncluded = response.included || [];
      this.loadingPending = false;
      m.redraw();
    }).catch(() => {
      this.pendingFeedbacks = [];
      this.loadingPending = false;
      m.redraw();
    });
  }
  loadReports() {
    if (!this.user) return;
    this.loadingReports = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/trader/reports',
      params: {
        filter: {
          user: this.user.id()
        }
      }
    }).then(response => {
      this.reports = response.data || [];
      this.reportsIncluded = response.included || [];
      this.loadingReports = false;
      m.redraw();
    }).catch(() => {
      this.reports = [];
      this.loadingReports = false;
      m.redraw();
    });
  }
  getUser(userId, included) {
    if (!userId) return null;
    const idStr = String(userId);
    let user = app.store.getById('users', idStr);
    if (!user && included && Array.isArray(included)) {
      const data = included.find(item => item.type === 'users' && String(item.id) === idStr);
      if (data) {
        user = app.store.pushPayload({
          data
        });
      }
    }
    return user;
  }
  renderUser(user, userId) {
    if (user) {
      return m(Link, {
        href: app.route.user(user),
        className: "ModerateUserFeedbackModal-userLink",
        target: "_blank"
      }, m(Avatar, {
        user: user
      }), m("strong", null, username(user)));
    }
    return m("span", {
      className: "ModerateUserFeedbackModal-userPlaceholder"
    }, m(Avatar, {
      user: null
    }), m("strong", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.user_id_format', {
      id: userId
    })));
  }
  approveFeedback(feedback) {
    if (!confirm(String(app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.confirm_approve')))) {
      return;
    }
    this.actionLoading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/trader/feedback/' + feedback.id + '/approve'
    }).then(() => {
      this.actionLoading = false;
      this.pendingFeedbacks = this.pendingFeedbacks.filter(f => f.id !== feedback.id);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.approved_success'));
      this.attrs.onAction?.();
      m.redraw();
    }).catch(() => {
      this.actionLoading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.error'));
      m.redraw();
    });
  }
  rejectFeedback(feedback) {
    if (!confirm(String(app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.confirm_reject')))) {
      return;
    }
    this.actionLoading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/trader/feedback/' + feedback.id + '/reject'
    }).then(() => {
      this.actionLoading = false;
      this.pendingFeedbacks = this.pendingFeedbacks.filter(f => f.id !== feedback.id);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.rejected_success'));
      this.attrs.onAction?.();
      m.redraw();
    }).catch(() => {
      this.actionLoading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.error'));
      m.redraw();
    });
  }
  dismissReport(report) {
    if (!confirm(String(app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.confirm_dismiss')))) {
      return;
    }
    this.actionLoading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/trader/reports/' + report.id + '/dismiss'
    }).then(() => {
      this.actionLoading = false;
      this.reports = this.reports.filter(r => r.id !== report.id);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.dismissed_success'));
      this.attrs.onAction?.();
      m.redraw();
    }).catch(() => {
      this.actionLoading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.error'));
      m.redraw();
    });
  }
  deleteReportFeedback(report) {
    if (!confirm(String(app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.confirm_delete')))) {
      return;
    }
    this.actionLoading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/trader/reports/' + report.id + '/reject'
    }).then(() => {
      this.actionLoading = false;
      this.reports = this.reports.filter(r => r.id !== report.id);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.deleted_success'));
      this.attrs.onAction?.();
      m.redraw();
    }).catch(() => {
      this.actionLoading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.error'));
      m.redraw();
    });
  }
  content() {
    return m("div", {
      className: "Modal-body ModerateUserFeedbackModal-body"
    }, m("div", {
      className: "TraderFeedbackTabs ModerateUserFeedbackModal-tabs"
    }, m("button", {
      type: "button",
      className: 'TabButton' + (this.activeTab === 'pending' ? ' active' : ''),
      onclick: () => {
        this.activeTab = 'pending';
      }
    }, m(Icon, {
      name: "fas fa-circle-check"
    }), m("span", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.pending_tab')), this.pendingFeedbacks.length > 0 && m("span", {
      className: "TabButton-badge"
    }, this.pendingFeedbacks.length)), m("button", {
      type: "button",
      className: 'TabButton' + (this.activeTab === 'reports' ? ' active' : ''),
      onclick: () => {
        this.activeTab = 'reports';
      }
    }, m(Icon, {
      name: "fas fa-flag"
    }), m("span", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.reports_tab')), this.reports.length > 0 && m("span", {
      className: "TabButton-badge TabButton-badge--warning"
    }, this.reports.length))), m("div", {
      className: "ModerateUserFeedbackModal-content"
    }, this.activeTab === 'pending' ? this.pendingContent() : this.reportsContent()));
  }
  pendingContent() {
    if (this.loadingPending) {
      return m("div", {
        className: "ModerateUserFeedbackModal-loading"
      }, m(LoadingIndicator, null));
    }
    if (this.pendingFeedbacks.length === 0) {
      return m("div", {
        className: "ModerateUserFeedbackModal-empty"
      }, m("div", {
        className: "ModerateUserFeedbackModal-emptyIcon"
      }, m(Icon, {
        name: "fas fa-circle-check"
      })), m("p", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.no_pending')));
    }
    return m("div", {
      className: "ModerateUserFeedbackModal-list"
    }, this.pendingFeedbacks.map(feedback => {
      const attrs = feedback.attributes || {};
      const fromUserId = feedback.relationships?.fromUser?.data?.id || feedback.relationships?.from?.data?.id || attrs.fromUserId || attrs.from_user_id;
      const toUserId = feedback.relationships?.toUser?.data?.id || feedback.relationships?.to?.data?.id || attrs.toUserId || attrs.to_user_id;
      const fromUser = this.getUser(fromUserId, this.pendingIncluded);
      const toUser = this.getUser(toUserId, this.pendingIncluded);
      const type = attrs.type || 'positive';
      const typeIcon = type === 'positive' ? 'thumbs-up' : type === 'negative' ? 'thumbs-down' : 'minus';
      const role = attrs.role || 'buyer';
      const roleIcon = role === 'buyer' ? 'cart-shopping' : role === 'seller' ? 'store' : 'right-left';
      const date = attrs.createdAt;
      return m("div", {
        className: `FeedbackCard FeedbackCard--${type}`,
        key: feedback.id
      }, m("div", {
        className: "FeedbackCard-header"
      }, m("div", {
        className: "FeedbackCard-users"
      }, m("div", {
        className: "FeedbackCard-user"
      }, this.renderUser(fromUser, fromUserId)), m(Icon, {
        name: "fas fa-arrow-right",
        className: "FeedbackCard-arrow"
      }), m("div", {
        className: "FeedbackCard-user"
      }, this.renderUser(toUser, toUserId))), m("div", {
        className: "FeedbackCard-meta"
      }, m(Badge, {
        type: type === 'positive' ? 'success' : type === 'negative' ? 'danger' : 'warning',
        icon: `fas fa-${typeIcon}`
      }), m("span", {
        className: "FeedbackCard-roleBadge"
      }, m(Icon, {
        name: `fas fa-${roleIcon}`
      }), m("span", null, app.translator.trans(`huseyinfiliz-traderfeedback.forum.form.role_${role}`))), date && m("span", {
        className: "FeedbackCard-dateBadge"
      }, m(Icon, {
        name: "far fa-clock"
      }), m("span", null, humanTime(new Date(date)))))), attrs.comment && m("div", {
        className: "FeedbackCard-comment"
      }, m("p", null, attrs.comment)), attrs.discussionId && m("a", {
        href: app.route('discussion', {
          id: attrs.discussionId
        }),
        className: "FeedbackCard-discussion",
        target: "_blank",
        rel: "noopener noreferrer"
      }, m(Icon, {
        name: "fas fa-comments"
      }), m("span", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.discussion_link'))), m("div", {
        className: "FeedbackCard-actions"
      }, m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-check",
        disabled: this.actionLoading,
        onclick: () => this.approveFeedback(feedback)
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.approve_button')), m(Button, {
        className: "Button Button--danger",
        icon: "fas fa-xmark",
        disabled: this.actionLoading,
        onclick: () => this.rejectFeedback(feedback)
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.reject_button'))));
    }));
  }
  reportsContent() {
    if (this.loadingReports) {
      return m("div", {
        className: "ModerateUserFeedbackModal-loading"
      }, m(LoadingIndicator, null));
    }
    if (this.reports.length === 0) {
      return m("div", {
        className: "ModerateUserFeedbackModal-empty"
      }, m("div", {
        className: "ModerateUserFeedbackModal-emptyIcon"
      }, m(Icon, {
        name: "fas fa-flag"
      })), m("p", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.no_reports')));
    }
    return m("div", {
      className: "ModerateUserFeedbackModal-list"
    }, this.reports.map(report => {
      const reportAttrs = report.attributes || {};
      const reporterId = report.relationships?.reporter?.data?.id || report.relationships?.user?.data?.id;
      const reporter = this.getUser(reporterId, this.reportsIncluded);
      const reportDate = reportAttrs.createdAt;
      const feedbackId = report.relationships?.feedback?.data?.id;
      const feedback = this.reportsIncluded.find(item => item.type === 'trader-feedbacks' && String(item.id) === String(feedbackId));
      let fromUser = null;
      let toUser = null;
      let fromUserId = null;
      let toUserId = null;
      let fbAttrs = {};
      let fbType = 'positive';
      let fbTypeIcon = 'thumbs-up';
      if (feedback) {
        fbAttrs = feedback.attributes || {};
        fromUserId = feedback.relationships?.fromUser?.data?.id || feedback.relationships?.from?.data?.id || fbAttrs.fromUserId || fbAttrs.from_user_id;
        toUserId = feedback.relationships?.toUser?.data?.id || feedback.relationships?.to?.data?.id || fbAttrs.toUserId || fbAttrs.to_user_id;
        fromUser = this.getUser(fromUserId, this.reportsIncluded);
        toUser = this.getUser(toUserId, this.reportsIncluded);
        fbType = fbAttrs.type || 'positive';
        fbTypeIcon = fbType === 'positive' ? 'thumbs-up' : fbType === 'negative' ? 'thumbs-down' : 'minus';
      }
      return m("div", {
        className: "ReportCard",
        key: report.id
      }, m("div", {
        className: "ReportCard-header"
      }, m("div", {
        className: "ReportCard-reporter"
      }, this.renderUser(reporter, reporterId)), reportDate && m("span", {
        className: "ReportCard-dateBadge"
      }, m(Icon, {
        name: "far fa-clock"
      }), m("span", null, humanTime(new Date(reportDate))))), reportAttrs.reason && m("div", {
        className: "ReportCard-reason"
      }, m("strong", null, app.translator.trans('huseyinfiliz-traderfeedback.forum.report_modal.reason_label'), ":"), m("p", null, reportAttrs.reason)), feedback && m("div", {
        className: "ReportCard-feedback"
      }, m("div", {
        className: "ReportCard-feedbackHeader"
      }, m("div", {
        className: "ReportCard-feedbackHeader-left"
      }, m("span", null, app.translator.trans('huseyinfiliz-traderfeedback.admin.reports.reported_feedback_label')), m(Badge, {
        type: fbType === 'positive' ? 'success' : fbType === 'negative' ? 'danger' : 'warning',
        icon: `fas fa-${fbTypeIcon}`
      }))), m("div", {
        className: "ReportCard-feedbackUsers"
      }, m("div", {
        className: "FeedbackCard-user"
      }, this.renderUser(fromUser, fromUserId)), m(Icon, {
        name: "fas fa-arrow-right",
        className: "FeedbackCard-arrow"
      }), m("div", {
        className: "FeedbackCard-user"
      }, this.renderUser(toUser, toUserId))), fbAttrs.comment && m("div", {
        className: "ReportCard-feedbackComment"
      }, m("p", null, fbAttrs.comment))), m("div", {
        className: "ReportCard-actions"
      }, m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-check",
        disabled: this.actionLoading,
        onclick: () => this.dismissReport(report)
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.dismiss_button')), m(Button, {
        className: "Button Button--danger",
        icon: "fas fa-trash",
        disabled: this.actionLoading,
        onclick: () => this.deleteReportFeedback(report)
      }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.delete_button'))));
    }));
  }
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/modals/ModerateUserFeedbackModal', ModerateUserFeedbackModal);